var map = {
	"./banner-1.jpg": "5f13",
	"./banner-2.jpg": "efb1",
	"./dingtalk.png": "7495",
	"./language.png": "0311",
	"./phone.png": "9b65",
	"./user-activation.jpg": "6da8",
	"./wechat.png": "5c76"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cb74";